import axios from "axios";
import * as types from "./types";

export default {
  [types.SAVE_RULE]: ({ commit }, payload) => {
    return axios
      .post("/working-hours-rules", payload)
      .then((resp) => {
        const rule = resp.data;
        commit(types.MUTATE_RULES, rule);
        return Promise.resolve(rule);
      })
      .catch((err) => {
        console.log('::: [DEBUG] Erro ao salvar regra:', err.message, err);
        return Promise.reject(err);
      });
  },

  [types.SEARCH_RULES]: ({ commit }, payload) => {
    const { level, entity_id, scale_id } = payload;
    if (!level || !entity_id) {
      return;
    }
    return axios
      .get("/working-hours-rules", {
        params: { level, entity_id, scale_id },
      })
      .then((resp) => {
        const rule = resp.data || null;

        commit(types.MUTATE_RULES, rule);
        return Promise.resolve(rule);
      })
      .catch((err) => {
        console.log('::: [DEBUG] Erro ao buscar regra:', err.message, err);
        commit(types.MUTATE_RULES, null);
        return Promise.reject(err);
      });
  },

  [types.DELETE_RULE]: ({ commit }, payload) => {
    const { id } = payload;

    return axios
      .delete(`/working-hours-rules/${id}`)
      .then((resp) => {
        commit(types.MUTATE_RULES, null);
        return Promise.resolve(resp.data);
      })
      .catch((err) => {
        console.log('::: [DEBUG] Erro ao deletar regra com id:', id, err.message, err);
        return Promise.reject(err);
      });
  },

  [types.GET_RULES_BY_GROUP_ID]: ({ commit }, payload) => {
    return axios
      .get(`/working-hours-rules/by-group/${payload}`)
      .then((resp) => {
        const rules = resp.data;
        commit(types.MUTATE_RULES_BY_GROUP, rules);
        return Promise.resolve(rules);
      })
      .catch((err) => {
        console.log('::: [DEBUG] Erro ao obter do grupo:', payload, err.message, err);
        commit(types.MUTATE_RULES_BY_GROUP, null);
        return Promise.reject(err);
      });
  },

  [types.GET_RULE_BY_ID]: ({ commit }, payload) => {
    const { id } = payload;

    return axios
      .get(`/working-hours-rules/${id}`)
      .then((resp) => {
        const rule = resp.data;

        commit(types.MUTATE_RULES, rule);
        return Promise.resolve(rule);
      })
      .catch((err) => {
        console.log('::: [DEBUG] Erro ao obter regra com id:', id, err.message, err);
        commit(types.MUTATE_RULES, null);
        return Promise.reject(err);
      });
  },

  //
  // Valida uma ou mais propostas de plantão em lote (contrato canônico do backend).
  // Diferente do CHECK_RULE_VIOLATION (proposta isolada), aqui o backend também
  // valida descanso mínimo entre as próprias propostas do lote (proposta×proposta).
  //
  // payload: {
  //   groupId: 'firebase group id',
  //   operation: 'create' | 'batch',
  //   items: [{ candidate_id, user_id, scale_id, start_at (ISO), duration_minutes }],
  // }
  //
  // Retorna: { code, title, message, data: { violated, can_force_create, summary_action, violations: [] } }
  //
  async [types.VALIDATE_RULES_BATCH](_context, payload) {
    try {
      const { groupId, items, operation, options } = payload;

      const response = await axios.post("/working-hours-rules/validate", {
        operation: operation || "batch",
        group_id: groupId,
        items,
        ...(options ? { options } : {}),
      });

      return response.data;
    } catch (error) {
      console.log('::: [DEBUG] Erro ao validar regras em lote:', error);
      return {
        code: "ERROR",
        message: "Erro ao verificar regras de carga horária.",
        data: { violated: false, can_force_create: true, summary_action: null, violations: [] },
      };
    }
  },

  //
  // Disparo de plantões via backend (POST /duties/dispatch): o servidor valida as
  // regras de carga horária e executa a escrita no Firebase. Substitui o
  // fbFullUpdate direto frontend→RTDB do "Disparar plantões".
  //
  // payload: { groupId, updates: { path: value }, force: boolean }
  // Retorna: { code: 'OK'|'RULE_VIOLATION'|..., title, message, data }
  //
  async [types.DISPATCH_DUTIES](_context, payload) {
    try {
      const { groupId, updates, force } = payload;

      const response = await axios.post("/duties/dispatch", {
        group_id: groupId,
        updates,
        force: force === true,
      });

      return response.data;
    } catch (error) {
      console.log('::: [DEBUG] Erro ao disparar plantões via backend:', error);
      return {
        code: "ERROR",
        message: "Não foi possível disparar os plantões. Por favor, tente novamente ou fale com nosso suporte.",
        data: null,
      };
    }
  },

  async [types.CHECK_RULE_VIOLATION](
    { commit },
    { userId, date, groupId, scaleId, turnId, duration, start_time }
  ) {
    try {
      const dateTimeStr = `${date} ${start_time}`;
      const dateWithZerosInDayAndMonth = new Date(
        dateTimeStr.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/,
          (match, year, month, day) => {
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          }
        )
      );
      const startTimestamp = dateWithZerosInDayAndMonth.getTime();

      const formattedDate = date
        .split("-")
        .map((part) => part.padStart(2, "0"))
        .join("-");
      const response = await axios.get(
        `/working-hours-rules/check/${userId}/${scaleId}/${groupId}`,
        {
          params: {
            date: formattedDate,
            duration: duration,
            start_time: startTimestamp,
          },
        }
      );

      commit(types.SET_RULE_VIOLATION, response.data);
      return response.data;
    } catch (error) {
      console.log('::: [DEBUG] Erro ao verificar violação de regra:', error);
      const errorResponse = {
        violated: false,
        message: "Erro ao verificar regras.",
      };
      commit(types.SET_RULE_VIOLATION, errorResponse);
      return errorResponse;
    }
  },
};
